<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ $t('myLogOffer.mnimTklifim') }}</h4>

      <div
        v-for="(p,i) in getPQTPrices()"
        :key="i"
      >
        <div class="row">
          <div class="col-6">
            <strong>
              {{ p.product.name }}
            </strong>
            <br>
            <span> {{ p.product.count }} {{ p.product.unit }} </span>
            <br>
            <strong>{{ $t("request.xsusiTlblr") }} </strong>
            <br>
            <span
              v-for="(req, index) in p.reqDetail"
              :key="`req-${index}`"
            >
              {{ `${index + 1}. ` }}{{ req.detail }} <br>
            </span>
            <br>
            <div
              v-for="(f,ii) in p.techSpecsFiles"
              :key="ii"
              class="col-md-12"
            >
              <a
                v-if="isPhoto(f)"
                target="_blank"
                :href="getPhoto(f,'')"
              >
                <img
                  :src="getPhoto(f,'medium','/images/no-image.png')"
                  class="img-thumbnail"
                  style="max-height: 200px;"
                  alt="-"
                >
              </a>
              <a
                v-else
                target="_blank"
                :href="getPhoto(f,'')"
                class="card border border-dark "
                style="height: 100%"
              >
                <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                  {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                </div>
              </a>
            </div>

            <span>
              <strong>{{ $t("myPQTOffer.texnikiSpesifikasiya") }}</strong> : {{ p.techSpecification }}
            </span>
          </div>
          <div class="col-6 text-right">
            <strong>
              {{ $t('offerExtrasView.azn', {price: p.price}) }}
            </strong>
          </div>
        </div>
        <hr>
      </div>
      <div v-if="myPQTOffer">
        <strong>{{ $t('myPQTOffer.tklifinEtibarllqTarixi') }} </strong>
        {{ $t('dashboardCompany.key', {moment: getMoment(myPQTOffer.valid)}) }} <br>
        <div
          v-if="myPQTOffer.files"
          class="mb-2"
        >
          <strong>{{ $t('myPQTOffer.fayllar') }}</strong> <br>
          <div class="row">
            <div
              v-for="(f,i) in myPQTOffer.files.split(',')"
              :key="i"
              class="col-md-3"
            >
              <a
                v-if="isPhoto(f)"
                target="_blank"
                :href="getPhoto(f,'')"
              >
                <img
                  :src="getPhoto(f,'medium','/images/no-image.png')"
                  class="img-thumbnail"
                  style="max-height: 200px;"
                  alt="-"
                >
              </a>
              <a
                v-else
                target="_blank"
                :href="getPhoto(f,'')"
                class="card border border-dark "
                style="height: 100%"
              >
                <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                  {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <hr>


      <div class="py-2   lead  d-flex justify-content-between ">
        {{ $t('myPQTOffer.toplamTklif') }} <span
          class="badge bg-warning"
        >{{ $t('myPQTOffer.azn', {totalPrice: offers[0].totalPrice}) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import {getPhoto} from "@/repositories/Utils";
import moment from "moment";

export default {
  name: 'MyPQTOffer',
  props: {
    products: {},
    offers: {},
    request: {}
  },

  computed: {
    myPQTOffer() {
      if (this.offers.length > 0) {
        return JSON.parse(this.offers[0].prices)['extras']
      }
      return null;
    },
    requirements() {
      if (this.offers.length > 0) {
        return JSON.parse(this.offers[0].prices)['prices']
      }
      return null;
    }
  },


  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getPQTPrices() {

      let prices = [];

      let json = JSON.parse(this.offers[0].prices);

      if (!json.prices) return [];
      json.prices.forEach((k) => {
        prices.push({
          product: this.getProductById(k.product),
          price: k.price,
          reqDetail: k.reqDetails,
          techSpecification: k.techSpecification,
          techSpecsFiles: k.techSpecsFiles
        })
      })
      console.log("prices", prices);
      return prices;

    },

    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },
  }
}
</script>
